import { render } from "./SemuaPegawai.vue?vue&type=template&id=6e8c4b9f"
import script from "./SemuaPegawai.vue?vue&type=script&lang=js"
export * from "./SemuaPegawai.vue?vue&type=script&lang=js"

import "./SemuaPegawai.vue?vue&type=style&index=0&id=6e8c4b9f&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__